import React from "react";
import clsx from "clsx";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import NavLink from "components/Router/NavLink";
import useStyles from "./styles";

type IDrawerItemProps = {
	icon: any;
	text: string;
	to: string;
	className?: string;
};

const DrawerItem = ({ icon, text, to, className }: IDrawerItemProps) => {
	const classes = useStyles();

	return (
		<ListItem
			to={to}
			component={NavLink}
			className={clsx(classes.listItem, className)}
			activeClassName={classes.activeListItem}
			button
			exact
		>
			<ListItemIcon className={classes.listItemIcon}>
				{icon}
			</ListItemIcon>
			<ListItemText primary={text} className={classes.listItemText} />
		</ListItem>
	);
};

export default DrawerItem;
